import { j as C } from "../../_virtual/jsx-runtime.js";
const l = ({
  width: r = 20,
  height: o = 20,
  viewBox: t = "0 0 20 20",
  fill: s = "currentColor",
  ...n
}) => /* @__PURE__ */ C.jsx(
  "svg",
  {
    width: r,
    height: o,
    viewBox: t,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: /* @__PURE__ */ C.jsx(
      "path",
      {
        d: "M14.2253 13.6722C15.606 13.6722 16.7253 14.7914 16.7253 16.1722C16.7253 17.5529 15.606 18.6722 14.2253 18.6722C12.8445 18.6722 11.7253 17.5529 11.7253 16.1722C11.7253 14.7914 12.8445 13.6722 14.2253 13.6722ZM5.89196 10.3388C7.73291 10.3388 9.22529 11.8312 9.22529 13.6722C9.22529 15.5131 7.73291 17.0055 5.89196 17.0055C4.05101 17.0055 2.55862 15.5131 2.55862 13.6722C2.55862 11.8312 4.05101 10.3388 5.89196 10.3388ZM14.2253 15.3388C13.765 15.3388 13.392 15.7119 13.392 16.1722C13.392 16.6324 13.765 17.0055 14.2253 17.0055C14.6855 17.0055 15.0586 16.6324 15.0586 16.1722C15.0586 15.7119 14.6855 15.3388 14.2253 15.3388ZM5.89196 12.0055C4.97148 12.0055 4.22529 12.7517 4.22529 13.6722C4.22529 14.5927 4.97148 15.3388 5.89196 15.3388C6.81243 15.3388 7.55862 14.5927 7.55862 13.6722C7.55862 12.7517 6.81243 12.0055 5.89196 12.0055ZM12.9753 2.00549C15.5066 2.00549 17.5586 4.05752 17.5586 6.58883C17.5586 9.12016 15.5066 11.1722 12.9753 11.1722C10.444 11.1722 8.39196 9.12016 8.39196 6.58883C8.39196 4.05752 10.444 2.00549 12.9753 2.00549ZM12.9753 3.67216C11.3645 3.67216 10.0586 4.97799 10.0586 6.58883C10.0586 8.19966 11.3645 9.50549 12.9753 9.50549C14.5861 9.50549 15.892 8.19966 15.892 6.58883C15.892 4.97799 14.5861 3.67216 12.9753 3.67216Z",
        fill: s
      }
    )
  }
);
export {
  l as default
};
